import React from 'react';
import './Footer.css';

function Footer() {

  return (
    <div className="footer">
      <h3>Thanks for visiting!</h3>
      <br />
      <p>If you'd like to say hi, you can email me <a href="mailto:roszko_anna@gmail.com">HERE</a>.</p>
    </div>
  );
}

export default Footer;